module.exports = __webpack_public_path__ + "img/corazon-borde-white.3fe59273.svg";